$(document).ready(() => { 
    let presentation = $('#view').length;
    console.log(presentation);
    let bigGrid = $('.bloc-chiffres');
    bigGrid.css('display','none');
    if(presentation == 1){
        bigGrid.css('display','block');
    }
});